import { BusinessClockStatus } from './core/time/business-clock-ui';
import { AfterViewInit, Component, OnDestroy, inject } from '@angular/core';
import { ModalInteractionManager } from './shared/utils/modal-interaction-manager';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, BusinessClockStatus],
    template: '<app-business-clock-status></app-business-clock-status><router-outlet></router-outlet>'
})
export class AppComponent implements AfterViewInit, OnDestroy {
  private readonly modalInteractions = new ModalInteractionManager();
  ngAfterViewInit(): void { this.modalInteractions.start(); }
  ngOnDestroy(): void { this.modalInteractions.stop(); }
  constructor() {
    const translate = inject(TranslateService);
    const router = inject(Router);
    translate.setFallbackLang('ja');
    translate.use('ja');
    router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    });
  }
}
